import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { data } from '../../composables/useData';
import { BarChart } from 'vue-chart-3';
import { Chart, registerables } from 'chart.js';
import { computed } from 'vue';
import dayjs from 'dayjs';

export default /*#__PURE__*/_defineComponent({
  __name: 'RegionData',
  setup(__props) {

Chart.register(...registerables);

const reportData = computed(() => {
  const report = data.loginUser.viewReports[data.loginUser.activeReport];

  // `regionData` を抽出
  const regionData = report.regionData;

  const labels = regionData.map(item => item.region);
  const activeUsers = regionData.map(item => item.activeUsers);
  const pageViews = regionData.map(item => item.pageViews);

  // チャートデータを整形する
  return {
    labels,
    datasets: [
      {
        label: 'アクティブユーザー数',
        data: activeUsers,
        backgroundColor: '#36A2EB',
      },
      {
        label: 'ページビュー数',
        data: pageViews,
        backgroundColor: '#FF6384',
      }
    ]
  };
});



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BarChart), {
    chartData: reportData.value,
    options: _unref(data).reportPage.graph.options
  }, null, 8, ["chartData", "options"]))
}
}

})